// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { createClient, deleteClient, getDetailClient, getListClient, updateClient } from './clientThunk';

export interface IClientState {
  isRefreshClientList: boolean;
  isRefreshClientDetail: boolean;
}

export const initialState: IClientState = {
  isRefreshClientList: false,
  isRefreshClientDetail: false,
};

const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    setRefreshClientList(state, action) {
      state.isRefreshClientList = action.payload;
    },
    setRefreshClientDetail(state, action) {
      state.isRefreshClientDetail = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list client
    builder
      .addCase(getListClient.pending, (_state) => {})
      .addCase(getListClient.fulfilled, (_state) => {})
      .addCase(getListClient.rejected, (_state) => {});

    // GET: Get detail client
    builder
      .addCase(getDetailClient.pending, (_state) => {})
      .addCase(getDetailClient.fulfilled, (_state) => {
        _state.isRefreshClientDetail = false;
      })
      .addCase(getDetailClient.rejected, (_state) => {});

    // POST: Create client
    builder
      .addCase(createClient.pending, (_state) => {})
      .addCase(createClient.fulfilled, (_state) => {})
      .addCase(createClient.rejected, (_state) => {});

    // PUT: Update client
    builder
      .addCase(updateClient.pending, (_state) => {})
      .addCase(updateClient.fulfilled, (_state) => {})
      .addCase(updateClient.rejected, (_state) => {});

    // DELETE: Delete client
    builder
      .addCase(deleteClient.pending, (_state) => {})
      .addCase(deleteClient.fulfilled, (_state) => {})
      .addCase(deleteClient.rejected, (_state) => {});
  },
});

// Action
export const clientActions = clientSlice.actions;

// Selectors
export const selectIsRefreshListClient = (state: RootState) => state.client.isRefreshClientList;
export const selectIsRefreshDetailClient = (state: RootState) => state.client.isRefreshClientDetail;

// Reducer
const clientReducer = clientSlice.reducer;
export default clientReducer;
